import gql from "graphql-tag";

export const CREATE_CREW_MUTATION = gql`
  mutation createCrew($jobNumber: Int, $code: String, $description: String ){
    createCrew(jobNumber: $jobNumber, code: $code, description: $description)
  }
`;